import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Tooltip } from "@mui/material";
import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField, DimensionDescriptor, ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { isAggregation, isCustomColumn, isMeasure, isMetric } from "../../../../utilities/fieldsHelper.ts";
import FieldItemWithConditions from "./FieldItemWithConditions.tsx";
import type { FieldItemProps } from "./area-fields/areaFiledItem.types.ts";

interface Props<MeasureField> extends FieldItemProps<MeasureField> {
  detailedView?: boolean;
  dimensions: DimensionDescriptor[];
  globalConditions: ConditionField[];
  canToggleParameter: boolean;
  isReadonlyCustomLabel: boolean;
  updateMeasure: ((field: ReportField, change: Partial<FieldConfiguration>) => void) | undefined;
}

const MeasureItem = <T extends ReportField>({ field, updateMeasure, ...props }: Props<T>) => (
  <FieldItemWithConditions
    {...props}
    field={field}
    updateField={updateMeasure}
    supportsCustomConditions={
      props.detailedView === undefined ||
      isAggregation(field) ||
      isMetric(field) ||
      (isMeasure(field) && field.meta.capabilities.customConditionsAllowed && !field.meta.capabilities.isScalar)
    }
  >
    {isCustomColumn(field) && field.invalid && (
      <Tooltip title="Invalid formula: one or more fields used in this formula have been removed or are no longer available. Edit the formula to resolve.">
        <ErrorOutlineIcon color="secondary" sx={{ ml: 1 }} />
      </Tooltip>
    )}
  </FieldItemWithConditions>
);

export default MeasureItem;
